import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicGuard, ProtectedGuard } from 'ngx-auth';
import { MapPageComponent } from './map/pages';
import { RoomSchedulePageComponent, MySchedulePageComponent, ClusterSchedulePageComponent, MyClusterSchedulePageComponent } from './schedule/pages';
import { HuntPageComponent } from './hunt/pages';
import { MePageComponent } from './me/pages';
import { MyTeamPageComponent } from './team/pages';
import { SignInPageComponent, SignOutPageComponent } from './core/authentication/pages';
import { MapModule } from './map/map.module';
import { ScheduleModule } from './schedule/schedule.module';
import { HuntModule } from './hunt/hunt.module';
import { MeModule } from './me/me.module';
import { TeamModule } from './team/team.module';

const routes: Routes = [
  { path: 'sign-in', component: SignInPageComponent, canActivate: [ PublicGuard ] },
  { path: 'sign-out', component: SignOutPageComponent, canActivate: [ ProtectedGuard ] },
  { path: '', redirectTo: '/map', pathMatch: 'full' },
  { path: 'map', component: MapPageComponent,  canActivate: [ ProtectedGuard ] },
  { path: 'hunt', component: HuntPageComponent, canActivate: [ ProtectedGuard ] },
  { path: 'me', component: MePageComponent, canActivate: [ ProtectedGuard ] },
  { path: 'team', component: MyTeamPageComponent, canActivate: [ ProtectedGuard ] },
  { path: 'schedule', children: [
      { path: 'my', component: MySchedulePageComponent,  canActivate: [ ProtectedGuard ] },
      { path: 'rooms/:room', component: RoomSchedulePageComponent,  canActivate: [ ProtectedGuard ] },
      { path: 'clusters', children: [
          { path: 'my', component: MyClusterSchedulePageComponent, canActivate: [ ProtectedGuard ]},
          { path: ':cluster', component: ClusterSchedulePageComponent, canActivate: [ ProtectedGuard ]}
        ]
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    MapModule,
    ScheduleModule,
    HuntModule,
    MeModule,
    TeamModule,
   ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts